import { ListGroup, ListGroupItem, Badge, NavItem } from 'reactstrap';
import { Link } from "react-router-dom";
import { FaExclamation, FaCheck } from 'react-icons/fa';


const ListadoAPE = (props) => {
    const returnIcon = (icon) => {
        switch (icon) {
            case 'FaCheck':
                return <FaCheck />
            case 'FaExclamation':
                return <FaExclamation />
            default:
                return <></>
        }
    }

    const returnTitle = (state) => {
        switch (state) {
            case 'PENDIENTE_APROBACION':
                return 'PENDIENTE APROBACION';
            case 'FINALIZADO':
            default:
                return 'FINALIZADO'
        }
    }
    if (props.listaSolicitudes.length > 0) 
    {
        return (
            <ListGroup>
                {
                    props.listaSolicitudes.map((solicitud, index) => {
                        return (
                            <div key={`divG_reclutamiento_${index}`} className='reclutamiento-list-item'>
                                <ListGroupItem onClick={() => { props.onClick(solicitud) }} key={`lisItem_reclutamiento_${index}`} color={solicitud.color}>
                                    <div key={`div_reclutamiento_${index}`} className='reclutamiento-list-area'>
                                        <p>{`${solicitud.text}`}</p>
                                        <div className='reclutamiento-list-buttons'>
                                            <div className='reclutamiento-list-buttons-item'>
                                                <Badge
                                                    color={solicitud.state === 'FINALIZADO' ? 'success' : 'success'}
                                                    pill
                                                >
                                                    {returnTitle(solicitud.state)}
                                                </Badge>
                                                {returnIcon(solicitud.customIcon)}
                                            </div>
                                        </div>
                                    </div>
                                </ListGroupItem>
                            </div>)
                    })
                }
            </ListGroup>
        );
    }
    else {
        return <div className='ape-list-nodata-text'>
            <p>No hay aprobaciones</p>
        </div>
    }
}

export default ListadoAPE